import { createStore, getActionIds } from '../helpers/redux';
import Immutable from 'immutable';

import { ModalActions } from '../actions/modal';
import { OrganizationActions } from '../actions/organization';
import { AccountActions } from '../actions/account';
import { ProjectActions } from '../actions/project';
import { ElementActions } from '../actions/element';
import { TagActions } from '../actions/tag';
import { ElementTypeActions } from '../actions/elementType';
import { RelationshipActions } from '../actions/relationship';
import { RelationshipTypeActions } from '../actions/relationshipType';
// import { CreateElementTypePropertyActions } from '../actions/forms/createElementTypeProperty';
import { BaselineActions } from '../actions/baseline';

const actions = getActionIds(ModalActions);
const organizationActions = getActionIds(OrganizationActions);
const accountActions = getActionIds(AccountActions);
const projectActions = getActionIds(ProjectActions);
const elementActions = getActionIds(ElementActions);
const elementTypeActions = getActionIds(ElementTypeActions);
const relationshipActions = getActionIds(RelationshipActions);
const relationshipTypeActions = getActionIds(RelationshipTypeActions);
// const elementTypePropertyActions = getActionIds(
//   CreateElementTypePropertyActions,
// );
const baselineActions = getActionIds(BaselineActions);
const tagActions = getActionIds(TagActions);

const initialState = Immutable.fromJS({
  showModal: false,
  isSubmitting: false,
  modals: [],
});

export const modal = createStore(initialState, {
  [projectActions.resetReducers]: (state, action) => {
    return initialState;
  },

  [actions.toggleModal]: (state, action) => {
    return state.merge({
      modals: state.get('modals').push(Immutable.fromJS(action.modal)),
    });
  },

  [tagActions.tagObject.success]: (state, action) => {
    return state.merge({
      showModal: false,
      modals: [],
    });
  },

  [relationshipActions.deleteRelationship.success]: (state, action) => {
    return state.merge({
      showModal: false,
      modals: [],
    });
  },

  [relationshipTypeActions.createRelationshipTypeMetaProperty.success]: (
    state,
    action,
  ) => {
    return state.merge({
      showModal: false,
      modals: [],
    });
  },

  [relationshipTypeActions.renameRelationshipTypeProperty.success]: (
    state,
    action,
  ) => {
    return state.merge({
      showModal: false,
      modals: [],
    });
  },

  [relationshipTypeActions.renameRelationshipTypeMetaProperty.success]: (
    state,
    action,
  ) => {
    return state.merge({
      showModal: false,
      modals: [],
    });
  },

  [relationshipTypeActions.createRelationshipType.success]: (state, action) => {
    return state.merge({
      showModal: false,
      modals: [],
    });
  },

  [relationshipTypeActions.createRelationshipTypeProperty.success]: (
    state,
    action,
  ) => {
    return state.merge({
      showModal: false,
      modals: [],
    });
  },

  [relationshipTypeActions.updateRelationshipTypeProperties.success]: (
    state,
    action,
  ) => {
    return state.merge({
      showModal: false,
      modals: [],
    });
  },

  [elementTypeActions.updateElementTypeProperties.success]: (state, action) => {
    return state.merge({
      showModal: false,
      modals: [],
    });
  },

  [elementTypeActions.createElementTypeMetaProperty.success]: (
    state,
    action,
  ) => {
    return state.merge({
      showModal: false,
      modals: [],
    });
  },

  [elementTypeActions.renameElementTypeProperty.success]: (state, action) => {
    return state.merge({
      showModal: false,
      modals: [],
    });
  },

  [elementTypeActions.renameElementTypeMetaProperty.success]: (
    state,
    action,
  ) => {
    return state.merge({
      showModal: false,
      modals: [],
    });
  },

  [elementTypeActions.createElementType.success]: (state, action) => {
    return state.merge({
      showModal: false,
      modals: [],
    });
  },

  [elementTypeActions.createElementTypeProperty.success]: (state, action) => {
    return state.merge({
      showModal: false,
      modals: [],
    });
  },

  [projectActions.createProject.success]: (state, action) => {
    return state.merge({
      modals: [],
    });
  },

  [projectActions.renameProjectProperty.success]: (state, action) => {
    return state.merge({
      modals: [],
    });
  },

  [projectActions.createCustomProperty.success]: (state, action) => {
    return state.merge({
      modals: [],
    });
  },

  [elementActions.createElement.success]: (state, action) => {
    return state.merge({
      modals: [],
    });
  },

  [actions.revealModal]: (state, action) => {
    return state.merge({
      showModal: true,
    });
  },

  [actions.hideModal]: (state, action) => {
    return state.merge({
      modals: [],
    });
  },

  [actions.backModal]: (state, action) => {
    return state.merge({
      modals: state.get('modals').pop(),
    });
  },

  [baselineActions.createBaseLine.success]: (state, action) => {
    return state.merge({
      modals: [],
    });
  },

  [organizationActions.renameOrganization.success]: (state, action) => {
    return state.merge({
      modals: [],
    });
  },

  [accountActions.renameAccount.success]: (state, action) => {
    return state.merge({
      modals: [],
    });
  },
});

export const modalSelector = (state, props) => {
  return state.modal.get('modals').last();
};

export const showModalSelector = (state, props) => {
  return state.modal.get('showModal');
};



// WEBPACK FOOTER //
// ./src/reducers/modal.js